import * as React from "react";
import PropTypes from 'prop-types';

const SvgHelp = props => {
  if (props.id !== "_svghelp") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 48 48" {...props}><path fill="#fff" d="M35.267 11H12.733c-.86 0-1.733.854-1.733 1.733v22.534c0 .85.836 1.733 1.625 1.733h22.642c.855-.015 1.733-.847 1.733-1.733V12.625c0-.762-.872-1.625-1.733-1.625zM24 32.017a.975.975 0 110-1.95.975.975 0 010 1.95zm1.75-7.59c-.408.458-.967 1.085-1 1.317v2.59a.75.75 0 01-1.5 0v-2.6c0-.756.61-1.44 1.381-2.306.93-1.043 2.086-2.34 2.086-3.761 0-1.08-1.116-2.284-2.717-2.284-2.742 0-2.928 2.24-2.935 2.336a.75.75 0 01-1.496-.104c.002-.037.305-3.732 4.431-3.732 1.026 0 2.07.38 2.864 1.04.872.728 1.353 1.702 1.353 2.744 0 1.992-1.425 3.591-2.466 4.76z" fillRule="evenodd" /></svg>;
};

SvgHelp.displayName = "_svghelp";
SvgHelp.propTypes = {
  id: PropTypes.string
};
SvgHelp.defaultProps = {
  id: ''
};
export default SvgHelp;